// RESET
export const RESET_STATE = 'RESET_STATE';

// SET_COUNTRIES
export const SET_COUNTRIES = 'SET_COUNTRIES';
export const SET_COUNTRIES_FOR_SELECT = 'SET_COUNTRIES_FOR_SELECT';

// FETCH_MEDIA
export const FETCH_MEDIA_PENDING = 'FETCH_MEDIA_PENDING';
export const FETCH_MEDIA_FULFILLED = 'FETCH_MEDIA_FULFILLED';
export const FETCH_MEDIA_ERROR = 'FETCH_MEDIA_ERROR';

export const FETCH_PRESS_RELEASES_FULFILLED = 'FETCH_PRESS_RELEASES_FULFILLED';
export const FETCH_MEDIA_REPORTS_FULFILLED = 'FETCH_MEDIA_REPORTS_FULFILLED';
export const FETCH_MEDIA_KITS_FULFILLED = 'FETCH_MEDIA_KITS_FULFILLED';

// FETCH_MEDIA
export const SEND_PROBLEM_REPORT_PENDING = 'SEND_PROBLEM_REPORT_PENDING';
export const SEND_PROBLEM_REPORT_FULFILLED = 'SEND_PROBLEM_REPORT_FULFILLED';
export const SEND_PROBLEM_REPORT_ERROR = 'SEND_PROBLEM_REPORT_ERROR';

// FETCH_MEDIA
export const FETCH_JOB_PENDING = 'FETCH_JOB_PENDING';
export const FETCH_JOB_FULFILLED = 'FETCH_JOB_FULFILLED';
export const FETCH_JOB_ERROR = 'FETCH_JOB_ERROR';

// FETCH_AVAM_OCCUPATION_CLASSIFICATIONS
export const FETCH_AVAM_OCCUPATION_CLASSIFICATIONS_PENDING = 'FETCH_AVAM_OCCUPATION_CLASSIFICATIONS_PENDING';
export const FETCH_AVAM_OCCUPATION_CLASSIFICATIONS_FULFILLED = 'FETCH_AVAM_OCCUPATION_CLASSIFICATIONS_FULFILLED';
export const FETCH_AVAM_OCCUPATION_CLASSIFICATIONS_ERROR = 'FETCH_AVAM_OCCUPATION_CLASSIFICATIONS_ERROR';
